/**
 * @file
 */

import { customValidationInit, aspControlValidationInit } from "@/common/validation/init.js";

export function InitializeGPLRfaInfoGetPage() {
   // ----------------------------------
   // initialize the validation engine
   // ----------------------------------
   var onSubmit = false;
   customValidationInit(onSubmit);
   aspControlValidationInit();

   charsRemaining("txtRequestedInformation", "sTxtRequestedInformation", 4999);

   $('input[id$="txtDateOfBirth"]').mask("99-99-9999");
};

/**
 * 
 * @param {string} tb
 * @param {string} lbl
 * @param {number} tbLength
 */
function charsRemaining(tb, lbl, tbLength) {
   $("[id$='" + tb + "']").keyup(function () {
      if (this.value.length > tbLength) {
         $("[id$='" + lbl + "']").html("Max Exceeded.");
         return false;
      }

      $("[id$='" + lbl + "']").html(tbLength - this.value.length);
   });
}
